import i18n from 'common/locale/i18n';

export const PNR_STATUS_ENUM = {
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
  BOOKED_CANCELLED: 'BOOKED_CANCELLED',
  CANCELLED_ISSUED: 'ISSUED_CANCELLED',
  FAILED: 'FAILED',
  ISSUED: 'ISSUED',
};

export const PNR_STATUS_LABEL_MAPPING = {
  [PNR_STATUS_ENUM.BOOKED]: i18n.getText('pnr_enum_booked'),
  [PNR_STATUS_ENUM.ISSUED]: i18n.getText('pnr_enum_issued'),
  [PNR_STATUS_ENUM.CANCELLED]: i18n.getText('pnr_enum_cancelled'),
  [PNR_STATUS_ENUM.BOOKED_CANCELLED]: i18n.getText('pnr_enum_cancelled'),
  [PNR_STATUS_ENUM.CANCELLED_ISSUED]: i18n.getText('pnr_enum_cancelled-issued'),
  [PNR_STATUS_ENUM.FAILED]: i18n.getText('pnr_enum_failed'),
};

export const PNR_STATUS_LIST = Object.values(PNR_STATUS_ENUM);
